<nav class="bg-white border-gray-200 w-full lg:text-sm">
  <cdk-accordion
    class="grid grid-cols-2 lg:flex gap-4 items-stretch justify-between p-4 lg:px-10 mx-auto"
  >
    <div class="lg:w-96 flex items-center gap-4">
      <a routerLink="/">
        <img
          src="/assets/img/logo_skillz.svg"
          alt="Skillz wordmark"
          class="h-[48px]"
          i18n-alt
        />
      </a>
      <app-ghosting class="justify-center"></app-ghosting>
    </div>
    <button
      type="button"
      class="justify-self-end inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-md lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
      aria-controls="navbar-cta"
      aria-expanded="false"
      data-testid="menu-button"
      (click)="toggleMobileNav()"
    >
      <span class="sr-only" i18n>Open main menu</span>
      <svg
        class="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 17 14"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 1h15M1 7h15M1 13h15"
        />
      </svg>
    </button>
    <div
      class="flex-wrap gap-4 justify-end w-full col-span-2 lg:flex lg:w-96 order-2 space-x-3 lg:space-x-0 rtl:space-x-reverse"
      [ngClass]="{ hidden: !opened }"
    >
      <div class="flex gap-4 items-center">
        <app-shopping-cart-icon></app-shopping-cart-icon>
        @if (user(); as user) {
          <ul
            class="font-medium pl-2 rounded-md lg:flex lg:p-0 lg:space-x-8 lg:items-center lg:flex-row rtl:space-x-reverse"
          >
            <li>
              <nav-menu
                [text]="user.firstName || profileText"
                class="hover:text-primary"
                data-testid="profile-nav"
              >
                <nav-menu-link
                  i18n-text
                  text="Customer Profile"
                  link="/profile"
                  (click)="toggleMobileNav()"
                ></nav-menu-link>
                @if (user | isMonitor) {
                  <nav-menu-link
                    i18n-text
                    text="Monitor Dashboard"
                    link="/portal/monitor"
                    (click)="toggleMobileNav()"
                  ></nav-menu-link>
                }
                @if (user | isExternal) {
                  <nav-menu-link
                    i18n-text
                    text="Organization Dashboard"
                    link="/portal/external/dashboard"
                    (click)="toggleMobileNav()"
                  ></nav-menu-link>
                }
                @if (user | isAdmin) {
                  <nav-menu-link
                    i18n-text
                    text="Admin Dashboard"
                    link="/portal/admin/dashboard"
                    (click)="toggleMobileNav()"
                  ></nav-menu-link>
                }
                <nav-menu-link
                  role="button"
                  i18n-text
                  text="Log out"
                  link="#"
                  (click)="auth.logout()"
                ></nav-menu-link>
              </nav-menu>
            </li>
          </ul>
        } @else if (user() === undefined) {
          <!-- Still loading -->
          <div class="animate-pulse w-20 h-[1rem] bg-gray-300"></div>
        } @else {
          <a
            class="button-outline button-outline-secondary text-sm"
            i18n-routerLink="@@//become-monitor"
            routerLink="/become-monitor"
            i18n
          >
            Apply for Monitor
          </a>
          <button
            class="button text-sm"
            data-testid="login-button"
            (click)="auth.loginWithRedirect()"
            i18n
          >
            Log In
          </button>
        }
      </div>
    </div>
    <div
      class="items-center justify-between w-full col-span-2 lg:flex lg:w-auto order-1"
      [ngClass]="{ hidden: !opened }"
    >
      <ul
        class="w-full flex flex-col justify-center font-medium pl-2 lg:p-0 rounded-md lg:space-x-8 rtl:space-x-reverse lg:flex-row"
      >
        <li class="pb-2 lg:p-0">
          <a
            class="hover:text-primary"
            routerLink="/"
            i18n
            (click)="toggleMobileNav()"
          >
            Home
          </a>
        </li>
        <li class="pb-2 lg:p-0">
          <nav-menu i18n-text text="Camps" class="hover:text-primary">
            <nav-menu-link
              i18n-text
              text="All camps"
              link="/courses"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
            @for (period of vacationPeriods; track $index) {
              <nav-menu-link
                [text]="period.label"
                [link]="period.link"
                (click)="toggleMobileNav()"
              ></nav-menu-link>
            }
            <nav-menu-link
              i18n-text
              text="Our locations"
              link="/locations"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
            <nav-menu-link
              i18n-text
              text="Our themes"
              link="/themes"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
          </nav-menu>
        </li>

        <li class="pb-2 lg:p-0">
          <nav-menu
            i18n-text
            text="Schools & organizations"
            class="hover:text-primary"
          >
            <nav-menu-link
              i18n-text
              text="Workshops"
              link="/workshops"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
            @if (provideAfterSchool) {
              <nav-menu-link
                i18n-text
                text="After school lessons"
                link="/after-school"
                (click)="toggleMobileNav()"
              ></nav-menu-link>
            }
            <nav-menu-link
              i18n-text
              text="Custom camps"
              link="/custom-camps"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
          </nav-menu>
        </li>

        <li class="pb-2 lg:p-0">
          <nav-menu class="hidden"></nav-menu>
          <nav-menu i18n-text text="Contact" class="hover:text-primary">
            <nav-menu-link
              i18n-text
              text="The Skillz team"
              link="/skillz-team"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
            <nav-menu-link
              i18n-text
              text="FAQ"
              i18n-link="@@//faq"
              link="/faq"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
            <nav-menu-link
              i18n-text
              text="Contact us"
              link="/contact-us"
              (click)="toggleMobileNav()"
            ></nav-menu-link>
          </nav-menu>
        </li>
      </ul>
    </div>
  </cdk-accordion>
</nav>
